import { render, staticRenderFns } from "./MerchantBannerForm.vue?vue&type=template&id=474f1de8&scoped=true"
import script from "./MerchantBannerForm.vue?vue&type=script&lang=js"
export * from "./MerchantBannerForm.vue?vue&type=script&lang=js"
import style0 from "./MerchantBannerForm.vue?vue&type=style&index=0&id=474f1de8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474f1de8",
  null
  
)

export default component.exports